import React, { useEffect, useImperativeHandle, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import Addresses from "./forms/Addresses";
import Contacts from "./forms/Contacts";
import Details from "./forms/Details";
import { getCompanyFullData } from "../../../../services/empresa";
import auth from "../../../../utils/auth";

const userInfo = () => {
    return auth.getUserInfo()
}

const Company = (props) => {
    const [detalhes, setDetalhes] = useState({});
    const [enderecos, setEnderecos] = useState([]);
    const [contatos, setContatos] = useState([]);

    const handleGetCompanyFullData = () => {
        getCompanyFullData(userInfo().empresa).then((res) => {
            const { detalhes, enderecos, contatos } = res;
            if (detalhes) {
                setDetalhes(detalhes);
            }
            if (enderecos) {
                setEnderecos(enderecos);
            }
            if (contatos) {
                setContatos(contatos);
            }
        })
    }

    useEffect(() => {
        handleGetCompanyFullData()
    }, []);

    useEffect(() => {
        props.onUpdateCompanyDetails(detalhes);
    }, [detalhes]);

    return (
        <div>
            <Details
                detalhes={detalhes}
                setDetalhes={setDetalhes}
            />
            <Tabs className="tabs-style">
                <TabList>
                    <Tab>Meus Endereços</Tab>
                    <Tab>Meus Contatos</Tab>
                </TabList>

                <TabPanel>
                    <Addresses
                        enderecos={enderecos}
                        userInfo={userInfo()}
                        fetchCompany={handleGetCompanyFullData}
                    />
                </TabPanel>

                <TabPanel>
                    <Contacts
                        contatos={contatos}
                        userInfo={userInfo()}
                        fetchCompany={handleGetCompanyFullData}
                    />
                </TabPanel>
            </Tabs>
        </div>
    );
};

export default Company;